import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
    providedIn:'root'
})

export class CurrencyPicklistService extends DatabaseGwService{
    URL_PATH: string = '/currency-picklists';
}